import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal, Edit, ExternalLink, Trash2 } from "lucide-react";
import type { UnifiedAsset } from "@/hooks/useAssetsUnified";

interface AssetsTableRowActionsProps {
  asset: UnifiedAsset;
  onViewDetails: (asset: UnifiedAsset) => void;
  onEdit: (asset: UnifiedAsset) => void;
  onDelete?: (asset: UnifiedAsset) => void;
}

export const AssetsTableRowActions: React.FC<AssetsTableRowActionsProps> = ({
  asset,
  onViewDetails,
  onEdit,
  onDelete,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="h-8 w-8 p-0"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={(e) => {
            e.stopPropagation();
            onViewDetails(asset);
          }}
        >
          <ExternalLink className="h-4 w-4 mr-2" />
          View Details
        </DropdownMenuItem>
        {asset.source_type === 'manual' && (
          <DropdownMenuItem 
            onClick={(e) => {
              e.stopPropagation();
              onEdit(asset);
            }}
          >
            <Edit className="h-4 w-4 mr-2" />
            Edit Asset
          </DropdownMenuItem>
        )}
        {asset.source_type === 'manual' && onDelete && (
          <DropdownMenuItem
            className="text-destructive focus:text-destructive"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(asset);
            }}
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
